import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ExchangeChat from '@/components/chat/ExchangeChat.vue'
import { reactive, watch } from 'vue'
import store from '@/store'
import { ElNotification } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationListener',
  setup(__props) {


const router = useRouter()
const route = useRoute()

const state = reactive<{
  currentExchangeId?: string
}>({
  currentExchangeId: undefined
})

// Наблюдаем за сообщениями по сделкам
watch(() => store.state.chatExchangeMessages.length, () => {
  const message = store.state.chatExchangeMessages[store.state.chatExchangeMessages.length - 1]
  if (message) {
    if (message.chatId === state.currentExchangeId) return

    const notification = ElNotification({
      type: 'success',
      title: 'Новое сообщение для сделки',
      message: message.message || 'Вложение',
      onClick: () => {
        state.currentExchangeId = message.chatId
        notification.close()
      }
    })
  }
})

// Наблюдаем за сообщениями в техподдержку от пользователя
watch(() => store.state.chatSupportMessages.length, () => {
  const message = store.state.chatSupportMessages[store.state.chatSupportMessages.length - 1]
  if (message) {
    if (route.name === 'support-chat' && route.params.chatId === message.chatId) return

    const notification = ElNotification({
      type: 'success',
      title: 'Новое сообщение',
      message: message.message || 'Вложение',
      onClick: () => {
        router.push({ name: 'tickets-chat', params: { chatId: message.chatId } })
        notification.close()
      }
    })
  }
})

// Наблюдаем за сообщениями в техподдержу от менеджера
watch(() => store.state.chatSupportUserMessages.length, () => {
  const message = store.state.chatSupportUserMessages[store.state.chatSupportUserMessages.length - 1]
  if (message) {
    if (route.name === 'support') return

    const notification = ElNotification({
      type: 'success',
      title: 'Новое сообщение',
      message: message.message || 'Вложение',
      onClick: () => {
        router.push({ name: 'support' })
        notification.close()
      }
    })
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ExchangeChat, {
    uuid: state.currentExchangeId,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (state.currentExchangeId = undefined))
  }, null, 8, ["uuid"]))
}
}

})